<template>
  <div id="live-teacher-player">
    <div class="live-teacher-player-placeholder"></div>
  </div>
</template>

<script>
const store = BJY.store;
const auth = BJY.auth;
const eventEmitter = BJY.eventEmitter;
const userData = BJY.data.user;
const config = BJY.config;
let player = null;
export default {
  components: {},
  data() {
    return {
    };
  },
  methods: {
    //创建老师播放器
    createTeacherPlayer(isWebRTCMix) {
      if (isWebRTCMix === undefined) {
        isWebRTCMix = auth.isWebRTC();
      }
      // Safari 下使用 HTML/FLV 播放 WebRTC 混流
      var isSafari = BJY.browser.safari || BJY.browser.safariWebview || (/safari/i.test(navigator.userAgent) && !/chrome|crios|crmo/i.test(navigator.userAgent))
      if (BJY.browser.wechat || isSafari) {
        isWebRTCMix = true;
      }
      isWebRTCMix && (store.get('webrtcMixUser').name = '老师');
      player && player.destroy();
      player = null;
      const user = auth.isPresenter()
        ? store.get("presenter")
        : isWebRTCMix
        ? store.get("webrtcMixUser")
        : store.get("presenter") || store.get("teacher");
      let extension = BJY.getExtension()
      if (BJY.browser.wechat || isSafari) {
        extension = BJY.Player.html
      }
      const options = {
        element: $(".live-teacher-player-placeholder"),
        replace: false,
        user: user,
        extension: extension,
        canSwitchCamera: auth.isSelf(store.get("teacher.id")),
        canSwitchMic: auth.isSelf(store.get("teacher.id"))
      };
      !auth.isTeacher() && (options.isWebRTCMix = isWebRTCMix);
      player = BJY.DefaultThemePlayer.create(options);
    },


  },
  created() {
    var playerInstance = player
    eventEmitter
      .on(eventEmitter.CLASS_START, (event, data) => {
        this.createTeacherPlayer();
        // 设置一下发言权限
        if (auth.isTeacher() || auth.isAssistant()) {
          store.set("class.speakState", config.SPEAK_STATE_FREE);
        }
        // 上课后老师自动开启音视频
        if (auth.isTeacher()) {
          eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
            audioOn: true,
            videoOn: true,
          });
        }
      })
      .on(eventEmitter.MEDIA_SWITCH_TRIGGER, function (event, data) {
        var _player = BJY.Player.instances[store.get("user.id")];
        _player && BJY.userPublish.setDevice(_player, data.videoOn, data.audioOn);
      })
      .on(
        // 老师打开媒体事件
        eventEmitter.TEACHER_MEDIA_ON,
        () => {
          // 判断播放器是否存在
          if (!player) {
            this.createTeacherPlayer();
          }
        }
      )
      .on(
        eventEmitter.MEDIA_STATUS_CHANGE,
        (e, data) => {
          console.log(data)
          if (data.videoOn || data.audioOn) {
            !auth.isPresenter() && this.createTeacherPlayer(false)
          } else {
            !auth.isPresenter() && this.createTeacherPlayer(true)
          }
        }
      )
      .on(
        // 主播关闭媒体事件
        eventEmitter.TEACHER_MEDIA_OFF,
        () => {
        }
      )
      .on(
        eventEmitter.CLASSROOM_CONNECT_SUCCESS,
        () => {
          this.createTeacherPlayer();
        }
      )
    // 监听主讲人切换
    !auth.isTeacher() &&
      store.watch("presenterId", (newPresenterId, oldPresenterId) => {
        var newPresenter = userData.find(newPresenterId);
        var oldPresenter = userData.find(oldPresenterId);
        // 先处理发言列表
        eventEmitter.ACTIVE_LIST_PRESENTER_CHANGE_TRIGGER =
          "active_list_presenter_change_trigger";
        eventEmitter.trigger(eventEmitter.ACTIVE_LIST_PRESENTER_CHANGE_TRIGGER, {
          newPresenter: newPresenter,
          oldPresenter: oldPresenter,
        });
        // 主讲播放器销毁重建，
        if (newPresenter) {
          if (player) {
            createTeacherPlayer();
          }
        }
      });

    const doc = document.documentElement
    // 全屏 esc 退出的问题
    if (doc.requestFullscreen) {
        document.addEventListener(
            'fullscreenchange',
            function () {
                var isFullscreen = playerInstance && playerInstance.isFullScreen

                if (document.fullscreen != isFullscreen && !document.fullscreen) {
                    eventEmitter.trigger(
                        eventEmitter.FULLSCREEN_EXIT_TRIGGER
                    );
                }
            }
        );
    }
    else if (doc.webkitRequestFullScreen) {
        document.addEventListener(
            'webkitfullscreenchange',
            function () {
                var isFullscreen = playerInstance && playerInstance.isFullScreen

                if (document.webkitIsFullScreen != isFullscreen && !document.webkitIsFullScreen) {
                    eventEmitter.trigger(
                        eventEmitter.FULLSCREEN_EXIT_TRIGGER
                    );
                }
            }
        );
    }
    else if (doc.mozRequestFullScreen) {
        document.addEventListener(
            'mozfullscreenchange',
            function () {
                var isFullscreen = playerInstance && playerInstance.isFullScreen

                if (document.mozFullScreen != isFullscreen && !document.mozFullScreen) {
                    eventEmitter.trigger(
                        eventEmitter.FULLSCREEN_EXIT_TRIGGER
                    );
                }
            }
        );
    }
  },
};
</script>

<style lang="scss">
.live-teacher-player-placeholder,
#live-teacher-player {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
